var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessagesEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 166,
    viewBox: "0 0 288 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_127_132973)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_127_132973)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 12.801,
    transform: "translate(62.5 44.1787)",
    fill: "#A7A7BE"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 25.4795,
    y: 60.9797,
    width: 30.3843,
    height: 30.3843,
    rx: 15.1922,
    fill: "#C5B3E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.0225,
    y: 63.8213,
    width: 197.498,
    height: 60,
    rx: 8,
    fill: "#F7F7F9"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_127_132973)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 16.001,
    transform: "translate(73.0225 75.8208)",
    fill: "#DEDEE6"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 16.001,
    transform: "translate(195.022 75.8208)",
    fill: "#DEDEE6"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 105,
    height: 16.001,
    transform: "translate(73.0225 99.8208)",
    fill: "#DEDEE6"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_127_132973",
    x: 18.5,
    y: 16.5,
    width: 251,
    height: 139,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0980392 0 0 0 0 0.0901961 0 0 0 0 0.168627 0 0 0 0.075 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_127_132973"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_127_132973",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_127_132973"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 243,
    height: 12.801,
    fill: "white",
    transform: "translate(22.5 44.1787)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_127_132973"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 181.498,
    height: 44,
    fill: "white",
    transform: "translate(73.0225 71.8213)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesEmptyState);
export default __webpack_public_path__ + "static/media/messages-empty-state.ac21282dd60fd5e6fd4117ebb268fd93.svg";
export { ForwardRef as ReactComponent };